import React from 'react';
import styles from '../Services.module.css';

interface ServicesEmptyStateProps {
  onClearFilters: () => void;
}

const ServicesEmptyState: React.FC<ServicesEmptyStateProps> = ({onClearFilters}) => (
  <div className={styles.emptyState}>
    <div className={styles.emptyIcon}>🔍</div>
    <h3 className={styles.emptyTitle}>No services or opportunities found</h3>
    <p className={styles.emptyDescription}>Try adjusting your search or filters</p>
    <button type="button" onClick={onClearFilters} className={styles.clearButton}>
      Clear Filters
    </button>
  </div>
);

export default React.memo(ServicesEmptyState);
